function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 17L12 1.54473",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 6.5L12 1.5L7 6.5",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 15V22H22V15",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgUpload = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Upload.2a050c9b.svg";
export { ForwardRef as ReactComponent };